import { SELECTOR_APP_CONTENT } from '@/constants';
import abstMf from '@/subview_plugins/Abst/manifest';
import descMf from '@/subview_plugins/Desc/manifest';
import clmsMf from '@/subview_plugins/Clms/manifest';

export const MICRO_NAME = 'micro-chemical-assistant';

export const MICRO_URL = `${process.env.VUE_APP_CHEMICAL_URI}/assistant.html`;

export const ASSISTANT_DOM_SELECTOR = '#bio_chemical_assistant'

export const CONTAINER_DOM_SELECTOR = SELECTOR_APP_CONTENT as string;

export const HEADER_DOM_SELECTOR = '.patent-app__header';

export const ABST_DOM_SELECTOR = '.abst-render';

export const DESC_DOM_SELECTOR = '.desc-render';

export const CLMS_DOM_SELECTOR = '.clms-render';

export const SUPPORTED_PATHS = [
    abstMf.exclusiveRoutePath as string,
    descMf.exclusiveRoutePath as string,
    clmsMf.exclusiveRoutePath as string,
];

export const UPDATE_BUTTON_VISIBLE_EVENT = 'chemical-assistant:updateButtonVisible';

export const UPDATE_HIGHLIGHT_ENABLED_EVENT = 'chemical-assistant:updateHighlightEnabled';
